import { FC } from 'react';

import CustomLoading from '../../CustomLoading';

import AddNoteModalHeader from './components/AddNoteModalHeader';
import AddNoteModalBody from './components/AddNoteModalBody';
import AddNoteModalFooter from './components/AddNoteModalFooter';

import { useAddNoteModal } from './context/AddNoteModalContext';

import '../Modals.scss';

const AddNoteModal: FC = () => {
  const { data } = useAddNoteModal();

  return (
    <>
      <AddNoteModalHeader />
      <AddNoteModalBody />
      <AddNoteModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddNoteModal;
